import React from 'react';
import Uganda_s2 from './uganda_s2';
import Uganda_s2_subjects from './uganda_s2_subjects';
const Uganda_s2ped = () => {
  return (
    <div>
      <Uganda_s2 />
    <Uganda_s2_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>PHYSICAL EDUCATION</h1>
      <h3>PE in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in PE learning and assessment </li>
      <li>Cross-cutting isues integrated in PE learning and assessment </li>
      <li>Values integrated in PE learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s2ped;